
import { Component, Vue } from "vue-property-decorator";
@Component({name: "ClientInfo"})
export default class ClientInfo extends Vue {
    get videoLink() {
        if(this.$i18n.locale === 'ru') {
            return "https://youtu.be/j-uiH9VO5uk";
        } 
            return "https://youtu.be/35m1yZIK10o";
        
    }
}
